import axios from 'axios'
import {message} from "ant-design-vue";
import router from '@/router'
// import { getCookie, delCookie ,setCookie,IsIPMode,setPersistenceCookie} from '@/utils/cookie';

message.config({
    maxCount: 1,
});

// http request 拦截器
axios.interceptors.request.use(
    config => {
		const accessToken = localStorage.getItem('accessToken')
		if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`

        return config;
    },
    err => {
        return Promise.reject(err);
    });

export default function ajax(url, data = {}, type = 'GET') {
    return new Promise((resolve, reject) => {
        let promise;
        // 1. 执行异步ajax请求
        if (type === 'GET') { // 发GET请求
            if(JSON.stringify(data) == "{}") {
                promise = axios.get(url)
            } else {
                promise = axios.get(url + data)
            }
        } else if (type === 'POST') { // 发POST请求
            promise = axios.post(url, data)
        } else if (type === 'PUT') { // 发POST请求
            promise = axios.put(url, data)
        } else if(type === 'DOWNLOAD'){
            promise = axios.get(url, {
                params: data,
                responseType:"blob"
            });
        } else if(type === 'download'){
            promise = axios.post(url,data,{
                responseType:"blob"
            });
        } else {
            console.error('暂不支持的请求类型');
            return;
        }
        // 2. 如果成功了, 调用resolve(value)
        promise.then(response => {
            if(type === 'DOWNLOAD'||type === 'download'){
                resolve(response)
            }else{
                response = response.data;
                if (response.code == 500) {
                    message.error(response.message);
                } else if (response.code == 200) {
                    resolve(response);
                } else {
                    message.error(response.message);
                    resolve(response);
                }
            }

        }).catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        if (error.response.data.message) {
                           message.error(error.response.data.message);
                        }
                        localStorage.removeItem('userData')
                        localStorage.removeItem('accessToken')
                        // if(IsIPMode()) {
                        //     router.push({
                        //         path: '/login?appKey='+ router.app._route.query.appKey
                        //     })
                        // }else{
                            router.push({
                                path: '/login'
                            })
                        // }
                        return;
                    case 302:
                        // let redirectUrlPath = window.location.href.match(/redirectUrl=(\S*)/)
                        //
                        // if(!redirectUrlPath) {
                        window.open(error.response.data.redirectUrl,'_self','noreferrer')
                        // }else{
                        //     redirectUrl()
                        // }
                        return;
                    case 403:
                         message.error('request forbidden');
                        return;
                    case 404:
                        message.error('request error, please try later');
                        return;
                    default:
                        message.error( error.message);
                        return;
                }
            }
            // console.error('请求出错了: ' + error.message);
        })
    })
}
